import { useTranslation } from 'react-i18next';

export default function TrustCards() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: 'ri-table-line',
      title: t('trust_spreadsheet_title'),
      desc: t('trust_spreadsheet_desc'),
    },
    {
      icon: 'ri-book-open-line',
      title: t('trust_guides_title'),
      desc: t('trust_guides_desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('trust_safety_title'),
      desc: t('trust_safety_desc'),
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group p-6 rounded-xl border border-stone-200 bg-stone-50/50 hover:bg-white hover:border-emerald-200 hover:shadow-sm transition-all"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-emerald-50 text-emerald-600 mb-4">
                <i className={`${card.icon} text-lg md:text-xl`} />
              </div>
              <h3 className="text-base md:text-lg font-semibold text-stone-800 mb-2">
                {card.title}
              </h3>
              <p className="text-sm text-stone-500 leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}